export class Anno {
  Nome: string;
  Codice: number;
}
